/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.26.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ChangeOrderStartDateTimeCommandFromJSON(json) {
    return ChangeOrderStartDateTimeCommandFromJSONTyped(json, false);
}
export function ChangeOrderStartDateTimeCommandFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'workorderId': !exists(json, 'workorderId') ? undefined : json['workorderId'],
        'newStartDate': !exists(json, 'newStartDate') ? undefined : (new Date(json['newStartDate'])),
    };
}
export function ChangeOrderStartDateTimeCommandToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'workorderId': value.workorderId,
        'newStartDate': value.newStartDate === undefined ? undefined : (value.newStartDate.toISOString()),
    };
}
